const setErrors = (errors, formTarget) => {
    let formElement = document.querySelector('form#' + formTarget);

    for (let [errorName, errorMessage] of Object.entries(errors)) {
        formElement.querySelector('input[name=' + errorName + ']').setCustomValidity(errorMessage);
        let errorDiv = formElement.querySelector('input[name=' + errorName + ']').nextElementSibling;
        if (errorMessage) {
            errorDiv.innerHTML = errorMessage;
        }
    }
}

const resetErrors = ( formTarget ) =>{
    let formElement = document.querySelector('form#' + formTarget);

    let formData = new FormData(formElement);

    for ( let [inputName,inputValue] of formData.entries()){
        formElement.querySelector('input[name=' +  inputName + ']').setCustomValidity('');
    }
}

export { setErrors, resetErrors };